// extracted by mini-css-extract-plugin
export default {"form":"styles_form__naFOz","resend-wrapper":"styles_resend-wrapper__mHoyi","link":"styles_link__KgGz-","buttons":"styles_buttons__prBqp"};